import { useEffect, useState } from 'react';
import { LuVolumeX, LuVolume2 } from 'react-icons/lu';
import { API } from '@unboared/react';

import { Button } from '~/components/ui/button';

export function MuteButton() {
    const [isMuted, setIsMuted] = useState(false);

    useEffect(() => {
        const unsub = API.onReady(() => {
            setIsMuted(API.isMute());
        });
        return unsub;
    }, []);

    const toggleMute = () => {
        setIsMuted(!isMuted);
        API.mute(!isMuted);
    };

    return <Button preset="secondary" icon={isMuted ? <LuVolumeX /> : <LuVolume2 />} onClick={toggleMute} />;
}
